import Project1 from "../../assets/project1.webp";
import Project2 from "../../assets/project2.webp";
import Project3 from "../../assets/project3.webp";


export const projectsData = [
    {
        id: 1,
        image: Project1,
        title: "AI  Summarizer",
        link: "https://sammurize.netlify.app/"
       
    },
    {
        id: 2,
        image: Project2,
        title: "CryptoHubNews",
        link:"https://cryptohubnews.netlify.app/"
       
    },
    {
        id: 3,
        image: Project3,
        title: "Japanese Flashcards",
        link:"https://japaneseflashcards.netlify.app/"
        
        
    },
    {
        id: 4,
        image: Project1,
        title: "Wandering Star|Trip Adviser",
        
    },
    {
        id: 5,
        image: Project2,
        title: "E-commerce",
        
       
    },

];

